export var ModelModificationCommand = function(modelModificationCmd, modelModificationPanel) {
  this.modelModificationCmd = modelModificationCmd;
  this.modelModificationPanel = modelModificationPanel;
}
ModelModificationCommand.prototype = {
  constructor: ModelModificationCommand,
  exec: function(scope) {
    if (this.modelModificationPanel.activeObject == undefined) {
      return;
    }
    if (this.modelModificationCmd === 0) {
      scope.sceneManager.toMoveModel(this.modelModificationPanel.activeObject);
      $('#modelModifiPanel').hide();
      this.modelModificationPanel.activeObject = undefined;
    } else if (this.modelModificationCmd === 1) {
      scope.$refs.modelModificationPanel.modelOper = 0;
      scope.$refs.modelModificationPanel.min = 0,
        scope.$refs.modelModificationPanel.max = 10,
        scope.$refs.modelModificationPanel.sliderstep = 0.1
      $('#modelSlider').show();
      $('#modelModBtnPanel').hide();

    } else if (this.modelModificationCmd === 2) {
      scope.$refs.modelModificationPanel.modelOper = 1;
      scope.$refs.modelModificationPanel.min = 0,
        scope.$refs.modelModificationPanel.max = 360,
        scope.$refs.modelModificationPanel.sliderstep = 5
      $('#modelSlider').show();
      $('#modelModBtnPanel').hide();
    } else if (this.modelModificationCmd === 3) {
      console.log('scope',scope)
      scope.sceneManager.geometryManager.deleteModel(this.modelModificationPanel.activeObject);
      $('#modelModifiPanel').hide();
      this.modelModificationPanel.activeObject = undefined;
    } else if (this.modelModificationCmd === 4) {
      this.modelModificationPanel.activeObject = undefined;
      $('#modelSlider').hide();
      $('#modelModBtnPanel').show();
      $('#modelModifiPanel').hide();
    } else if (this.modelModificationCmd === 5) {
      var modelModPanel = scope.$refs.modelModificationPanel;
      if (modelModPanel.modelOper == 0) {

        scope.sceneManager.geometryManager.scaleModel(this.modelModificationPanel.activeObject, modelModPanel.sliderVal);
      } else if (modelModPanel.modelOper == 1) {
        scope.sceneManager.geometryManager.rotateModel(this.modelModificationPanel.activeObject, modelModPanel.sliderVal);
      }
      return;
    } else if (this.modelModificationCmd === 6) {
      var activeObject = this.modelModificationPanel.activeObject;
      var objLoader = activeObject.loader;
      objLoader.showRoute({
        id: 1,
        nodes: [
          { x: activeObject.position.x + 40, z: activeObject.position.z - 40 },
          { x: activeObject.position.x + 30, z: activeObject.position.z - 35 },
          { x: activeObject.position.x + 20, z: activeObject.position.z - 15 },
          { x: activeObject.position.x + 20, z: activeObject.position.z - 10 },
          { x: activeObject.position.x, z: activeObject.position.z }
        ]
      });

      objLoader.animateRoute();
       $('#modelModBtnPanel').show();
      $('#modelModifiPanel').hide();
    }


  }
}



// WEBPACK FOOTER //
// ./src/plugins/components/Web3dModels/commands/ModelModificationCommand.js